import axios from "axios";
import BaseApi from "../BaseApi";
import CertificateAPI from "../Certificate";
import { RenameAndSignResponseType, SelectedAttachsType, SignedInfoListType, SignedInfoRequestType, ZipAttachsByMRType } from "src/Types/Task/ZipAttachsByMR";
import { TransitionCompleteResponse } from "Src/Types/Task";
import APICertificate from "../Certificate";

export default class ZipAttachsByMR_API extends BaseApi {

	/** Получение данных задачи */
	static getData = async ( fileId: string, componentId: string ): Promise<ZipAttachsByMRType> => {
		const url = `${window.host}/ZipAttachsByMR/Task?fileId=${fileId}&componentId=${componentId}`;
		try {
			const request = await axios.get( url , { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при получении данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при получении данных задачи" );
		}
	};

	/**  */
	static signSelected = async ( data: SelectedAttachsType ): Promise<TransitionCompleteResponse> => {
		if ( !data.thumbprint ) {
			throw new Error( "Не указан отпечаток сертификата!" );
		}
		const signInfo = await this._signSelectedAttachs( data );
		const sourceArray = JSON.parse(signInfo.digestArray);
		const digest = await CertificateAPI.getSignListWithHash(sourceArray, data.thumbprint, signInfo.hashAlgId );
		if ( !!digest.length ) {
			const newData: SignedInfoListType = {
				...signInfo,
				digestList: digest
			};
			return this._saveSignAttachments( newData );
		}
		throw new Error( "Ошибка при подписании выбранных аттачментов" );
	};

	/** */
	static zipped = async ( data: SelectedAttachsType ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/Zipped";
		try {
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при архивировании." );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при архивировании." );
		}
	};

	/** */
	static signDescription = async ( data: SelectedAttachsType ): Promise<any> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/SignDescription";
		try {
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при сохранении подписи аттачментов в дело." );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при сохранении подписи аттачментов в дело." );
		}
	};

	/** Подписать и сформировать архив */
	static signAndZip = async ( props: SelectedAttachsType ): Promise<any> => {
		const data: SelectedAttachsType = { ...props };
		if ( !data.thumbprint ) return;
		if ( !data.certificate ) {
			const cert = await CertificateAPI.getCertInfoByThumbprint( data.thumbprint );
			data.certificate = cert.base64;
		}
		const response = await this._autoSignAttachments( data );
		const info = [];
		for (let index = 0; index < response.hashes.length; index++) {
			const hash = response.hashes[index];
			const signed = await APICertificate.signHash( hash.hash, response.hashAlgId, data.thumbprint );
			if ( signed.success ) {
				info.push( {
					attachmentId: hash.attachmentId,
					hash: signed.data
				});
			}
		}
		if ( !!info.length ) {
			const newData = { 
				fileId: data.fileId,
				componentId: data.componentId,
				info: ""
			};
			newData.info = JSON.stringify( info );
			return this._saveNewSignAttachmentList( newData );
		}
	};

	/** Подписать и сформировать архив */
	static createZipWithRename = async ( fileId: string, componentId: string, thumbprint: string ): Promise<any> => {
		if ( !thumbprint ) return;
		const cert = await CertificateAPI.getCertInfoByThumbprint( thumbprint );
		const certificate = cert.base64;
		const response = await this._renameFilesAndSign( fileId, componentId, thumbprint, certificate );
		const info = [];
		for (let index = 0; index < response.hashes.length; index++) {
			const hash = response.hashes[index];
			const signed = await APICertificate.signHash( hash.hash, response.hashAlgId, thumbprint );
			if ( signed.success ) {
				info.push( {
					attachmentId: hash.attachmentId,
					hash: signed.data
				});
			}
		}
		if ( !!info.length ) {
			const newData = { 
				fileId,
				componentId,
				info: ""
			};
			newData.info = JSON.stringify( info );
			return this._saveNewSignAttachmentList( newData );
		}
	};

	/** Сформировать архив */
	static createZip = async ( fileId: string, componentId: string, thumbprint: string ): Promise<any> => {
		if ( !thumbprint ) return;
		const cert = await CertificateAPI.getCertInfoByThumbprint( thumbprint );
		const certificate = cert.base64;
		const data: SelectedAttachsType = { fileId, componentId, thumbprint, certificate };
		const response = await this._autoSignAttachments( data );
		const info = [];
		for (let index = 0; index < response.hashes.length; index++) {
			const hash = response.hashes[index];
			const signed = await APICertificate.signHash( hash.hash, response.hashAlgId, thumbprint );
			if ( signed.success ) {
				info.push( {
					attachmentId: hash.attachmentId,
					hash: signed.data
				});
			}
		}
		if ( !!info.length ) {
			const newData = { 
				fileId,
				componentId,
				info: ""
			};
			newData.info = JSON.stringify( info );
			return this._saveNewSignAttachmentList( newData );
		}
	};

	/**  */
	static _renameFilesAndSign = async ( fileId: string, componentId: string, thumbprint: string, certificate: string ): Promise<RenameAndSignResponseType> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/RenameFilesAndSign";
		const data = { fileId, componentId, thumbprint, certificate };
		try {
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при переименовании, подписании и формирования архива" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при переименовании, подписании и формирования архива" );
		}
	};

	/**  */
	static _autoSignAttachments = async ( props: SelectedAttachsType ): Promise<RenameAndSignResponseType> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/AutoSignAttachments";
		const data: SelectedAttachsType = { ...props };
		if ( !!props.attachRecIds ) {
			data.attachRecIds = props.attachRecIds;
		}
		try {
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при авто-подписании и формирования архива" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при авто-подписании и формирования архива" );
		}
	};

	/** Сохраняет подписи аттачментов в дело. */
	static _saveSignAttachments = async ( data: SignedInfoListType ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/SaveSignAttachments";
		try {
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при сохранении подписи аттачментов в дело." );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при сохранении подписи аттачментов в дело." );
		}
	};

	/** Завершает формирование архива после подписания на клиенте */
	static _saveNewSignAttachmentList = async ( props: SignedInfoRequestType ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/SaveNewSignAttachmentList";
		try {
			const request = await axios.post( url , props, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при формирование архива после подписания на клиенте" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при формирование архива после подписания на клиенте" );
		}
	};

	/**  */ 
	static _signSelectedAttachs = async ( data: SelectedAttachsType ): Promise<SignedInfoListType> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ZipAttachsByMR/ZipAttachsByMR/SignSelectedAttachs";
		try {
			if ( !!data.thumbprint && !data.certificate ) {
				const base64 = await CertificateAPI.getCertInfoByThumbprint( data.thumbprint );
				data.certificate = base64.base64;
			}
			const request = await axios.post( url , data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при подписании аттачментов." );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			console.warn( error );
			throw new Error("Ошибка при подписании аттачментов." );
		}
	};

};